// Mapping between language values and locale codes
const LOCALE_MAP = {
  'english': 'en',
  'hindi': 'hi',
  'bengali': 'bn',
  'telugu': 'te',
  'tamil': 'ta',
  'marathi': 'mr',
  'gujarati': 'gu',
  'kannada': 'kn',
  'malayalam': 'ml',
  'punjabi': 'pa',
  'odia': 'or',
  'urdu': 'ur',
};

// Create a reactive reference to track the current language
import { ref } from 'vue';
export const currentLanguage = ref(localStorage.getItem('preferredLanguage') || 'english');

/**
 * Update the i18n locale based on language value
 * @param {string} languageValue - The language value (e.g., 'english', 'hindi')
 * @returns {boolean} - Whether the update was successful
 */
export function updateI18nLocale(languageValue) {
  // Store in localStorage
  localStorage.setItem('preferredLanguage', languageValue);
  
  // Update our reactive reference
  currentLanguage.value = languageValue;
  
  // Convert from language value (english, hindi) to locale code (en, hi)
  const localeCode = LOCALE_MAP[languageValue] || 'en';
  
  // Update the i18n locale
  if (window.__i18n && window.__i18n.global) {
    window.__i18n.global.locale.value = localeCode;
    return true;
  }
  return false;
}

/**
 * Get translation for a key (dynamic translation)
 * @param {string} key - The translation key (e.g., 'header.home')
 * @returns {string} - The translated text or the key itself if not found
 */
export function dt(key, params = {}) { 
  const i18n = window.__i18n
  if (!i18n || !i18n.global || !i18n.global.messages || !i18n.global.messages.value) {
    console.warn('🔍 i18n not available, returning key:', key)
    return key
  }
  
  const currentLocale = LOCALE_MAP[currentLanguage.value] || 'en'
  const messages = i18n.global.messages.value[currentLocale]
  
  if (!messages) {
    console.warn('🔍 No messages for locale:', currentLocale)
    return key
  }
  
  const keys = key.split('.')
  let result = messages
  
  for (const k of keys) {
    if (result && typeof result === 'object' && k in result) {
      result = result[k]
    } else {
      return key
    }
  }
  
  // Replace placeholders with params
  if (typeof result === 'string' && Object.keys(params).length > 0) {
    return result.replace(/\{(\w+)\}/g, (match, paramKey) => {
      return params[paramKey] !== undefined ? params[paramKey] : match
    })
  }
  
  return result || key
}

/**
 * Get current locale code
 * @returns {string} - The current locale code (e.g., 'en', 'hi')
 */
export function getCurrentLocaleCode() {
  return LOCALE_MAP[currentLanguage.value] || 'en'
}